import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-http-backend';
import languageDetector from 'i18next-browser-languagedetector';
import { locates } from '@root/services/locates';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(backend)
  .use(languageDetector)
  .use(initReactI18next)
  .use(ICU)
  .init({
    fallbackLng: 'ru',
    react: {
      useSuspense: false
    },
    lng: localStorage.getItem('i18nextLng') || 'ru',
    resources: locates,
    detection: {
      caches: []
    }
  });
